
import React from "react"
import { InputProps } from "./input"
import { cn } from "@/lib/utils"
import { SearchIcon } from "lucide-react"

export type SearchProps = React.InputHTMLAttributes<HTMLInputElement>;

const Search = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => {
    return (
      <div
        className={cn(
          "flex h-10 items-center rounded-[15px] border border-input bg-[#FFFEFA] pl-3 text-sm ring-offset-background",
          className,
        )}
      >
        <SearchIcon className="h-[16px] w-[16px]" color="#888888" />
        <input
          {...props}
          type="search"
          ref={ref}
          className=" p-2 outline-none placeholder:text-[#888888] focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50 "
        />
      </div>
    );
  },
);

Search.displayName = "Search";

export { Search };